import { Component } from '@angular/core';
import { MunilyIconAreaCardStatus } from 'src/app/common-components/icon-area-card/icon-area-card.types';

@Component({
  selector: 'app-icon-area-card-playground',
  templateUrl: './icon-area-card-playground.component.html',
  styleUrls: ['./icon-area-card-playground.component.scss'],
})
export class IconAreaCardPlaygroundComponent {
  title = 'Basketball court';

  status: MunilyIconAreaCardStatus = 'default';
  disabled = false;

  imageUrl = '';
  icon = 'sports_basketball';
  iconSet: 'material-symbols-rounded' | 'material-icons' | 'material-icons-outlined' = 'material-symbols-rounded';

  lastEvent = '';

  readonly statuses: MunilyIconAreaCardStatus[] = ['default', 'selected'];
  readonly iconSets = ['material-symbols-rounded', 'material-icons', 'material-icons-outlined'] as const;

  onSelect(): void {
    this.lastEvent = `select @ ${new Date().toLocaleTimeString()}`;
  }
}

